module.exports = __webpack_public_path__ + "img/htc_cc.4b89a841.svg";